// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"f986f097","319":"d6600f17","335":"041f99e0","425":"e0af7048","453":"3edf9d94","474":"711dbb71","542":"8c9a0d31","578":"d480152f","586":"6282e2b0","886":"6680e567"}[chunkId] + ".chunk.js";
};